import ConditionalExceptionClauseType from '../../store/schema/ConditionalExceptionClauseType';

export default function getConditionalExceptionClauseTypeOptions(): ConditionalExceptionClauseType[] {
    //******** MUST READ ********//
    // Must keep in order by dropdown section!
    return [
        // Addresses
        'from',
        'to',

        // My name is
        'onTheToLine',
        'onTheCcLine',
        'onTheToOrCcLine',
        'notOnTheToLine',
        'theOnlyRecipientListed',

        // Subject
        'subjectIncludes',
        'subjectOrBodyIncludes',

        // Includes these words
        'inTheBody',
        'inTheSenderAddress',
        'inTheRecipientAddress',
        'inTheMessageHeader',

        // Marked with
        'withImportance',
        'sensitivity',

        // Message includes
        // 'classification',
        'flag',
        'type',
        'attachment',

        // Message size
        'atLeast',
        'atMost',

        // Received
        'before',
        'after',

        // All messages
        'any',
    ];
}
